import { useState, useEffect, useContext } from "react";
import {
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
} from "@mui/material";
import moment from "moment";
import { IoMdEye } from "react-icons/io";
//Import from project
import "../../../Style/pagestyle.scss";
import EmptyData from "../../Include/EmptyData/EmptyData";
import ViewImage from "../../Student/ViewImage";
import LoadingPage from "../../../Utils/LoadingPage";
import CheckAttendance from "./CheckAttendance";
import AttendanceHeader from "./AttendanceHeader";
import ReasonAttendance from "./ReasonAttendance";
import { AuthContext } from "../../../Context/AuthContext";
import { SelectScheduleByClass } from "../../Include/DynamicSelect/DynamicSelect";
import { SelectDatePicker } from "../../Include/SelectDatePicker/SelectDatePicker";
import useGetStudentForAttendanceList from "../../../Hooks/useGetStudentForAttendanceList";
import ViewAttendnaceReport from "./ViewAttendnaceReport";
import { ButtonCreate } from "../../../Utils/Component";

export default function Attendance({ classId }) {
  // Change Language
  const { t } = useContext(AuthContext);
  const [date, setDate] = useState(moment());
  const [scheduleVal, setScheduleVal] = useState({ id: "", title: "" });

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { loading, refetch, tableData } = useGetStudentForAttendanceList({
    id: classId,
    date: date,
    scheduleId: scheduleVal?.id,
  });

  // console.log("tableData::", tableData)
  // ========================= Resize width Screen ========================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <div className="page-container">
      <Box sx={{ marginTop: "10px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={3} lg={2} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_date")}
            </Typography>
            <SelectDatePicker value={date} onChange={(val) => setDate(val)} />
          </Grid>

          <Grid item xs={6} sm={6} md={3} lg={2} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_schedule")}
            </Typography>
            <SelectScheduleByClass
              className="text-field"
              value={scheduleVal}
              classId={classId}
              onChange={(val) => setScheduleVal(val)}
            />
          </Grid>

          <Grid item xs={10} sm={10} md={9} lg={8} xl={6}>
            <AttendanceHeader tableData={tableData} />
          </Grid>

          <Grid item xs={2} sm={2} md={3} lg={12} xl={2}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn="btn-create"
              classIcon="icon-add"
              title={t("view_attendance")}
              icon={<IoMdEye />}
            />

            {open && (
              <ViewAttendnaceReport
                classId={classId}
                open={open}
                handleClose={handleClose}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="10%">
                  {t("thead_id")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="15%">
                  {t("thead_student")}
                </TableCell>

                <TableCell className={t("class-name-header-title")} width="7%">
                  {t("thead_gender")}
                </TableCell>

                <TableCell className={t("class-name-header-title")} width="10%">
                  {t("thead_day")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title")}
                  width="20%"
                  align="center"
                >
                  {t("thead_attendance")}
                </TableCell>

                <TableCell className={t("class-name-header-title")} width="7%">
                  {t("thead_new_student")}
                </TableCell>

                <TableCell
                  className={t("class-name-header-title-end")}
                  width="29%"
                >
                  {t("thead_reason")}
                </TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.studentData?.length === 0 ? (
                  <TableBody className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody className="body">
                    {tableData?.studentData?.map((row, index) => {
                      // console.log("row::", row);
                      return (
                        <TableRow className={"body-row"} key={index}>
                          <TableCell className="body-cell-start">
                            {index + 1}
                          </TableCell>
                          <TableCell className="body-cell">
                            {row?.studentId}
                          </TableCell>
                          <TableCell className="body-cell">
                            <ViewImage
                              stuName={row?.familyName + " " + row?.studentName}
                              profileImg={row?.profile}
                            />
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.gender === "Male"
                              ? t("thead_male")
                              : t("thead_female")}
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.scheduleId?.[0]?.day
                              ? row.scheduleId[0].day
                              : ""}
                            {row?.scheduleId?.[1]?.day
                              ? `, ${row.scheduleId[1].day}`
                              : ""}
                            {row?.scheduleId?.[2]?.day
                              ? `, ${row.scheduleId[2].day}`
                              : ""}
                            {/* {!row?.scheduleId?.[0]?.day &&
                              !row?.scheduleId?.[1]?.day &&
                              !row?.scheduleId?.[2]?.day &&
                              "--- : ---"} */}
                          </TableCell>

                          <TableCell className="body-cell" align="center">
                            <CheckAttendance
                              date={date}
                              classId={classId}
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>

                          <TableCell className="body-cell">
                            {row?.isNewStudent && (
                              <Box className="btn-new-stu">
                                {t("thead_new_student")}
                              </Box>
                            )}
                          </TableCell>

                          <TableCell className="body-cell-end" align="right">
                            <ReasonAttendance
                              date={date}
                              classId={classId}
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
